module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "Title",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }, [_vm._v("Sea Cliff")])]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-8",
    attrs: {
      "alt": "Photo of garden.",
      "src": "image/01_Sea_Cliff_2017.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "LEDE _idGenCharOverride-2"
  }, [_vm._v("Avid and accomplished\n\t\t\t\t\tsailors,")]), _vm._v(" these homeowners were immediately smitten by this spectacular\n\t\t\t\tbluff-top site with its panoramic ocean, island, and mountain views. The existing\n\t\t\t\thouse was to receive a complete makeover. The landscape, I was informed, was to be\n\t\t\t\t“midcentury mid-Pacific.” With a couple of photos provided by the owner to guide the\n\t\t\t\tvision—one of a calm sea dotted with islands at sunset, another of a Japanese\n\t\t\t\twoodblock print that put me in mind of waves—the design process was begun. A design\n\t\t\t\tthat included movement, a rolling floor plane, a few Asian notes, and some\n\t\t\t\tdrought-tolerant, tropical-feel plantings—with lots of amenities for enjoying being\n\t\t\t\toutdoors—ought to do the trick. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The design solutions are natural and repetitive. Landscape mounds\n\t\t\t\tevoke dunes, emphasizing the seaside location and hearkening back to the inspiration\n\t\t\t\tphotos of waves and islands. Broad concrete pavers are used throughout the garden to\n\t\t\t\tcreate different effects: massed together, they provide seating areas; blended with\n\t\t\t\trecycled materials, they form a rich mosaic underfoot; and set as single\n\t\t\t\tbrushstrokes, they lead the eye to the expansive views. A spectacular\n\t\t\t\tbiergarten-style bench is suspended over the cliff on I-beams (left behind when an\n\t\t\t\told deck tumbled into the abyss). Sand-filled trays between the beams provide a\n\t\t\t\t“beach” to delight bare toes—and to prevent anyone from accidentally slipping over\n\t\t\t\tthe edge. Sitting at this table, soaring high above the waves with the wind blowing\n\t\t\t\toff the ocean, takes your breath away. The experience creates an illusion of being\n\t\t\t\tin a swift-sailing boat. This is a magical place to enjoy vibrant sunsets, passing\n\t\t\t\thang gliders, and migrating whales. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Plantings were selected for erosion control, low water demand, high\n\t\t\t\thabitat value, and aesthetics.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "Photo of table and bench at cliff edge.",
      "src": "image/15_Sea_Cliff_2017_CMYK.jpg"
    }
  })])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "CTL"
  }, [_vm._v("A narrow biergarten-style table and bench are suspended over the cliff’s\n\t\t\t\tedge, providing a bird’s-eye view of the beach below.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "Photo of garden.",
      "src": "image/02_Sea_Cliff_2017.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-11",
    attrs: {
      "alt": "Photo of garden.",
      "src": "image/17_Sea_Cliff_2017.jpg"
    }
  })])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "CTL"
  }, [_vm._v("A fieldstone bench does double duty as a retaining wall and as fireside\n\t\t\t\tseating. Steel I-beams, remnants of an old deck, were integrated into the patio\n\t\t\t\tpaving.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-12",
    attrs: {
      "alt": "Photo of garden.",
      "src": "image/30_Sea_Cliff_2017_CMYK.jpg"
    }
  })])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "CTL"
  }, [_vm._v("Broad concrete pavers lead to the entertaining area and draw the eye to\n\t\t\t\tthe expansive view. ")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-13",
    attrs: {
      "alt": "Photo of garden.",
      "src": "image/25_Sea_Cliff_2017.jpg"
    }
  })])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "CTL"
  }, [_vm._v("The hot tub is perched on preexisting infrastructure, allowing it to be\n\t\t\t\tlocated at the cliff’s edge without disturbing the highly erodible bluff. ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdc9fd9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Private_Gardens_Santa_Barbara_Interiors1.vue
// module id = 63
// module chunks = 0